import { d2hms, d2dms } from "../utils/functions";

function TargetsTable({ targets, onDelete }) {

    return (
        <table id="targets_table">
            <tbody>
            {targets.map(target => (
                <tr key={target.name}>
                    <td>{target.name}</td>
                    <td><code className="text-secondary">{d2hms(target.ra)} {d2dms(target.dec)}</code></td>
                    <td>
                        <button title="Delete this target" className="btn btn-link" onClick={() => onDelete(target.name)}>
                            <i className="bi bi-trash text-danger"></i>
                        </button>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default TargetsTable;